/**
 * Created by eriksundqvist on 10/05/16.
 */

/* @flow */
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import InvoiceValidator from 'redux/modules/invoice/invoice-validator';

export class Specification extends React.Component {

  static propTypes = {
    specification: PropTypes.string.isRequired,
    setSpecification: PropTypes.func.isRequired,
    submitted: PropTypes.bool.isRequired,
    translationPrefix: PropTypes.string.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      isExpanded: false,
      specification: '',
      specificationTouched: false
    };

    this.setSpecification = this.setSpecification.bind(this);
    this.blurSpecification = this.blurSpecification.bind(this);
    this.toggleExpandedStyle = this.toggleExpandedStyle.bind(this);
    this.setSpecificationHeight = this.setSpecificationHeight.bind(this);
  }

  componentWillReceiveProps (props) {
    this.setState({
      specification: props.specification
    });
  }

  setSpecification (event) {
    this.props.setSpecification(event.target.value);
    this.setSpecificationHeight(this.state.isExpanded);
  }

  blurSpecification () {
    this.setState({
      specificationTouched: true
    });
  }

  renderError () {
    if ((this.state.specificationTouched || this.props.submitted) &&
      !InvoiceValidator.validateSpecification(this.state.specification)) {
      return (<p className="error"><Translate content='INVOICE_ERROR_SPECIFICATION' /></p>);
    }
  }

  toggleExpandedStyle () {
    this.setState({
      isExpanded: !this.state.isExpanded
    });

    this.setSpecificationHeight(!this.state.isExpanded);
  }

  setSpecificationHeight (isExpanded) {
    var specification = document.getElementsByClassName('invoice-tool-specification')[0];
    if (isExpanded) {
      specification.style.height = specification.scrollHeight + 'px';
      specification.style.overflowY = 'hidden';
    } else {
      specification.style.height = '140px';
      specification.style.overflowY = 'scroll';
    }
  }

  renderExpandButton () {
    var specification = document.getElementsByClassName('invoice-tool-specification')[0];

    if (specification && specification.scrollHeight > 140) {
      return (<div className='invoice-tool-specification-button-container'>
        <button onClick={this.toggleExpandedStyle}>
          <img src={this.state.isExpanded
            ? require('images/icons/shrink.svg')
            : require('images/icons/expand.svg')} />
        </button>
      </div>);
    }

    return null;
  }

  render () {
    return (
      <div>
        <h3><Translate content='INVOICE_DESCRIPTION' /></h3>
        <p><Translate content={this.props.translationPrefix + 'INVOICE_TEXT'} /></p>
        <div className='invoice-tool-specification-container'>
          <textarea
            className='invoice-tool-specification'
            name='specification'
            value={this.state.specification}
            onChange={this.setSpecification}
            onBlur={this.blurSpecification}
          />
          {this.renderExpandButton()}
        </div>
        {this.renderError()}
      </div>
    );
  }
}

export default Specification;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/specification/specification.js
 **/